import { render } from "./DashChartListingLoader.vue?vue&type=template&id=fd4457ca"
import script from "./DashChartListingLoader.vue?vue&type=script&lang=js"
export * from "./DashChartListingLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__